// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import {sendBabyListOffer} from "../../actions/baby"
import type {Dispatch} from "../../types"

type Props = {
  +t: any,
  +babyToken: string,
  +isFirstOffer: boolean,
  +dispatch: Dispatch,
  +handleCloseModal: () => void,
  +handleAfterOpen: () => void,
}

type State = {
  +message: string,
}

class SendOfferModal extends React.Component<Props, State> {
  handleSendOffer: () => void
  handleInputChange: (SyntheticInputEvent<HTMLTextAreaElement>) => void

  state = {
    message: "",
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      message: props.isFirstOffer
        ? props.t("intake.sendOffer.initialDefault")
        : "",
    }

    this.handleSendOffer = this.handleSendOffer.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleInputChange(e: SyntheticInputEvent<HTMLTextAreaElement>) {
    this.setState({message: e.currentTarget.value})
  }

  handleSendOffer() {
    const {message} = this.state
    const {dispatch, babyToken} = this.props
    dispatch(sendBabyListOffer(babyToken, message))
    this.props.handleCloseModal()
  }

  render() {
    const {t} = this.props
    const {message} = this.state
    return (
      <Modal
        className="modal-dialog"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleCloseModal}
        onAfterOpen={this.props.handleAfterOpen}
        contentLabel={t(`intake.sendOffer.title`)}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t(`intake.sendOffer.title`)}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("intake.sendOffer.close")}
              onClick={this.props.handleCloseModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <p>{t(`intake.sendOffer.info`)}</p>
            <div className="form-group">
              <textarea
                className="form-control"
                rows="20"
                autoFocus={true}
                value={message}
                onChange={this.handleInputChange}
              />
            </div>
            <button
              className="btn btn-primary mr-4"
              onClick={this.handleSendOffer}
            >
              {t("intake.sendOffer.send")}
            </button>
            <a
              href="https://docs.google.com/document/d/1IBhM8XRUZPf7L8JcjlgdVLVLFthOD-aTezPk1GdWoc0/edit?usp=sharing"
              target="blank"
            >
              {t("modal.emailCopyDocLink")}
            </a>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(connect()(SendOfferModal))
